<div class="fixed-size-field font-larger" style="justify-content: flex-start">{{feedback.respondent.full_name}}</div>
<div class="ion-text-center fixed-size-field font-larger">{{feedback.created_at | amDateFormat : 'DD / MM / YY' }}</div>
<div class="description font-small" style="align-items: flex-end;">
    <div class="open-link no-print" *ngIf="!show" (click)="this.show = !this.show">
        <span>{{ "__REVIEW_REPORT_GOALS_AND_OBJECTIVES_VIEW_MORE__" | translate }}</span><img style="transform: rotate(.5turn);" src="assets/img/arrow-up-green.svg" alt="">
    </div>
    <div class="close-link no-print" *ngIf="show" (click)="this.show = !this.show">
        <span>{{ "__REVIEW_REPORT_GOALS_AND_OBJECTIVES_VIEW_LESS__" | translate }}</span><img src="assets/img/arrow-up-green.svg" alt="">
    </div>
</div>
<div *ngIf="show" class="inputs">
    <ng-content></ng-content>
</div>
